import i18n from '@/lang';
/* unplugin-vue-components disabled */
import __unplugin_components_10 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/CustomFormList/DatetimeRange.vue';
import __unplugin_components_9 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/CustomFormList/DatetimeRange.vue';
import __unplugin_components_8 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/CustomFormList/DatetimeRange.vue';
import __unplugin_components_7 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/Base/SelectPicker/index.vue';
import __unplugin_components_6 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/CustomFormList/SmyCheckBox.vue';
import __unplugin_components_5 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/FileUpload.vue';
import __unplugin_components_4 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/ScanCell.vue';
import __unplugin_components_3 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/PositionCell.vue';
import __unplugin_components_2 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/ImgUpload.vue';
import __unplugin_components_1 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/CustomFormList/SmyXAddress.vue';
import __unplugin_components_0 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/CustomFormList/PopupCheckList.vue';
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.fieldKey === 1 ? _c('div', [_c('Group', [_c('XTextarea', {
    attrs: {
      "title": i18n.tc("369"),
      "placeholder": i18n.tc("239"),
      "autosize": true,
      "show-counter": false,
      "rows": 1
    },
    model: {
      value: _vm.item.tfvvalue,
      callback: function ($$v) {
        _vm.$set(_vm.item, "tfvvalue", $$v);
      },
      expression: "item.tfvvalue"
    }
  }, [_c('div', {
    style: {
      position: 'relative',
      width: _vm.labelWidth + 'px'
    },
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm.item.is_required && _vm.item.is_required === 1 ? _c('span', {
    staticClass: "form-red-star"
  }, [_vm._v("*")]) : _vm._e(), _vm._v(" " + _vm._s(_vm.item.name || i18n.tc("372")) + " ")])])], 1)], 1) : _vm.fieldKey === 2 ? _c('div', [_vm.item.type === 2 ? _c('group', {
    key: _vm.item.id
  }, [_c('x-input', {
    attrs: {
      "title": i18n.tc("373"),
      "type": "text",
      "placeholder": i18n.tc("374"),
      "is-type": _vm.numberValidate,
      "show-clear": true
    },
    model: {
      value: _vm.item.tfvvalue,
      callback: function ($$v) {
        _vm.$set(_vm.item, "tfvvalue", $$v);
      },
      expression: "item.tfvvalue"
    }
  }, [_c('div', {
    style: {
      position: 'relative',
      width: _vm.labelWidth + 'px'
    },
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm.item.is_required && _vm.item.is_required === 1 ? _c('span', {
    staticClass: "form-red-star"
  }, [_vm._v("*")]) : _vm._e(), _vm._v(" " + _vm._s(_vm.item.name || i18n.tc("373")) + " ")])])], 1) : _vm._e()], 1) : _vm.fieldKey === 3 ? _c('div', [_vm.item.type === 3 ? _c('group', {
    key: _vm.item.id
  }, [_c('popup-picker', {
    attrs: {
      "show-name": "",
      "title": i18n.tc("375"),
      "placeholder": i18n.tc("237"),
      "value-text-align": "right",
      "columns": 1,
      "data": _vm.item.dropList,
      "value": [_vm.item.ovalue]
    },
    on: {
      "on-show": _vm.pickerFcous,
      "on-change": function ($event) {
        _vm.item.ovalue = $event.join(',');
      }
    }
  }, [_c('div', {
    style: {
      position: 'relative',
      width: _vm.labelWidth + 'px'
    },
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm.item.is_required && _vm.item.is_required === 1 ? _c('span', {
    staticClass: "form-red-star"
  }, [_vm._v("*")]) : _vm._e(), _vm._v(" " + _vm._s(_vm.item.name || i18n.tc("376")) + " ")])])], 1) : _vm._e()], 1) : _vm.fieldKey === 4 ? _c('div', [_vm.item.type === 4 ? _c('group', {
    key: _vm.item.id
  }, [_c('datetime', {
    attrs: {
      "format": "YYYY-MM-DD",
      "placeholder": i18n.tc("237")
    },
    on: {
      "on-show": _vm.pickerFcous
    },
    model: {
      value: _vm.item.tfvvalue,
      callback: function ($$v) {
        _vm.$set(_vm.item, "tfvvalue", $$v);
      },
      expression: "item.tfvvalue"
    }
  }, [_c('div', {
    style: {
      position: 'relative',
      width: _vm.labelWidth + 'px'
    },
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm.item.is_required && _vm.item.is_required === 1 ? _c('span', {
    staticClass: "form-red-star"
  }, [_vm._v("*")]) : _vm._e(), _vm._v(" " + _vm._s(_vm.item.name || i18n.tc("377")) + " ")])])], 1) : _vm._e()], 1) : _vm.fieldKey === 5 ? _c('div', [_vm.item.type === 5 ? _c('group', {
    key: _vm.item.id
  }, [_c('datetime', {
    attrs: {
      "format": "HH:mm",
      "placeholder": i18n.tc("237")
    },
    on: {
      "on-show": _vm.pickerFcous
    },
    model: {
      value: _vm.item.tfvvalue,
      callback: function ($$v) {
        _vm.$set(_vm.item, "tfvvalue", $$v);
      },
      expression: "item.tfvvalue"
    }
  }, [_c('div', {
    style: {
      position: 'relative',
      width: _vm.labelWidth + 'px'
    },
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm.item.is_required && _vm.item.is_required === 1 ? _c('span', {
    staticClass: "form-red-star"
  }, [_vm._v("*")]) : _vm._e(), _vm._v(" " + _vm._s(_vm.item.name || i18n.tc("292")) + " ")])])], 1) : _vm._e()], 1) : _vm.fieldKey === 6 ? _c('div', [_vm.item.type === 6 ? _c('group', {
    key: _vm.item.id
  }, [_c('datetime', {
    attrs: {
      "format": "YYYY-MM-DD HH:mm",
      "placeholder": i18n.tc("237")
    },
    on: {
      "on-show": _vm.pickerFcous
    },
    model: {
      value: _vm.item.tfvvalue,
      callback: function ($$v) {
        _vm.$set(_vm.item, "tfvvalue", $$v);
      },
      expression: "item.tfvvalue"
    }
  }, [_c('div', {
    style: {
      position: 'relative',
      width: _vm.labelWidth + 'px'
    },
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm.item.is_required && _vm.item.is_required === 1 ? _c('span', {
    staticClass: "form-red-star"
  }, [_vm._v("*")]) : _vm._e(), _vm._v(" " + _vm._s(_vm.item.name || i18n.tc("378")) + " ")])])], 1) : _vm._e()], 1) : _vm.fieldKey === 7 ? _c('div', [_vm.item.type === 7 ? _c('group', {
    key: _vm.item.id
  }, [_c('x-switch', {
    attrs: {
      "title": _vm.item.name,
      "value-map": [0, 1]
    },
    model: {
      value: _vm.item.ovalue,
      callback: function ($$v) {
        _vm.$set(_vm.item, "ovalue", $$v);
      },
      expression: "item.ovalue"
    }
  })], 1) : _vm._e()], 1) : _vm.fieldKey === 8 ? _c('div', [_vm.item.type === 8 ? _c('group', {
    key: _vm.item.id
  }, [_c(__unplugin_components_0, {
    attrs: {
      "show-name": "",
      "value-text-align": "right",
      "placeholder": i18n.tc("237"),
      "title": _vm.item.name,
      "data": _vm.item.dropList
    },
    model: {
      value: _vm.item.ovalue,
      callback: function ($$v) {
        _vm.$set(_vm.item, "ovalue", $$v);
      },
      expression: "item.ovalue"
    }
  }, [_c('div', {
    style: {
      position: 'relative',
      width: _vm.labelWidth + 'px'
    },
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm.item.is_required && _vm.item.is_required === 1 ? _c('span', {
    staticClass: "form-red-star"
  }, [_vm._v("*")]) : _vm._e(), _vm._v(" " + _vm._s(_vm.item.name || i18n.tc("379")) + " ")])])], 1) : _vm._e()], 1) : _vm.fieldKey === 9 ? _c('div', [_vm.item.type === 9 ? _c('group', {
    key: _vm.item.id
  }, [_c(__unplugin_components_1, {
    attrs: {
      "placeholder": i18n.tc("237")
    },
    on: {
      "on-change": function (ids, names) {
        return _vm.xAddressOnChange(_vm.item, ids, names);
      }
    },
    model: {
      value: _vm.item.ovalue,
      callback: function ($$v) {
        _vm.$set(_vm.item, "ovalue", $$v);
      },
      expression: "item.ovalue"
    }
  }, [_c('div', {
    style: {
      position: 'relative',
      width: _vm.labelWidth + 'px'
    },
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm.item.is_required && _vm.item.is_required === 1 ? _c('span', {
    staticClass: "form-red-star"
  }, [_vm._v("*")]) : _vm._e(), _vm._v(" " + _vm._s(_vm.item.name || i18n.tc("380")) + " ")])])], 1) : _vm._e()], 1) : _vm.fieldKey === 10 || _vm.fieldKey === 26 ? _c('div', [_vm.item.type === 10 || _vm.item.type === 26 ? _c('group', {
    key: _vm.item.id
  }, [_c(__unplugin_components_2, {
    attrs: {
      "hidden-border": "",
      "waterMask": _vm.getWaterMask(_vm.item),
      "onlyCamera": _vm.onlyCamera || _vm.getCamera(_vm.item)
    },
    on: {
      "on-change": function ($event) {
        _vm.item.tfvvalue = $event.join(',');
      }
    },
    model: {
      value: _vm.item.ovalue,
      callback: function ($$v) {
        _vm.$set(_vm.item, "ovalue", $$v);
      },
      expression: "item.ovalue"
    }
  }, [_c('div', {
    style: {
      position: 'relative',
      width: _vm.labelWidth + 'px'
    },
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm.item.is_required && _vm.item.is_required === 1 ? _c('span', {
    staticClass: "form-red-star"
  }, [_vm._v("*")]) : _vm._e(), _vm._v(" " + _vm._s(_vm.item.name || i18n.tc("381")) + " ")])])], 1) : _vm._e()], 1) : _vm.fieldKey === 11 ? _c('div', [_vm.item.type === 11 ? _c('group', {
    key: _vm.item.id
  }, [_c(__unplugin_components_3, {
    attrs: {
      "placeholder": i18n.tc("382"),
      "address": _vm.item.tfvvalue.split(',')
    },
    on: {
      "on-change": function (pos, addr) {
        return _vm.item.tfvvalue = addr + "," + addr + "," + pos.join(',');
      }
    },
    model: {
      value: _vm.item.ovalue,
      callback: function ($$v) {
        _vm.$set(_vm.item, "ovalue", $$v);
      },
      expression: "item.ovalue"
    }
  }, [_c('div', {
    style: {
      position: 'relative',
      width: _vm.labelWidth + 'px'
    },
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm.item.is_required && _vm.item.is_required === 1 ? _c('span', {
    staticClass: "form-red-star"
  }, [_vm._v("*")]) : _vm._e(), _vm._v(" " + _vm._s(_vm.item.name || i18n.tc("100")) + " ")])])], 1) : _vm._e()], 1) : _vm.fieldKey === 12 ? _c('div', [_vm.item.type === 12 ? _c('group', {
    key: _vm.item.id
  }, [_c(__unplugin_components_4, {
    model: {
      value: _vm.item.tfvvalue,
      callback: function ($$v) {
        _vm.$set(_vm.item, "tfvvalue", $$v);
      },
      expression: "item.tfvvalue"
    }
  }, [_c('div', {
    style: {
      position: 'relative',
      width: _vm.labelWidth + 'px'
    },
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm.item.is_required && _vm.item.is_required === 1 ? _c('span', {
    staticClass: "form-red-star"
  }, [_vm._v("*")]) : _vm._e(), _vm._v(" " + _vm._s(_vm.item.name || i18n.tc("100")) + " ")])])], 1) : _vm._e()], 1) : _vm.fieldKey === 13 ? _c('div', [_vm.item.type === 13 ? _c('group', {
    key: _vm.item.id
  }, [_c('x-textarea', {
    staticClass: "smy__textarea",
    attrs: {
      "show-counter": "",
      "name": "detail",
      "title": i18n.tc("160"),
      "placeholder": i18n.tc("239"),
      "max": 500
    },
    model: {
      value: _vm.item.tfvvalue,
      callback: function ($$v) {
        _vm.$set(_vm.item, "tfvvalue", $$v);
      },
      expression: "item.tfvvalue"
    }
  }, [_c('div', {
    style: {
      position: 'relative',
      width: _vm.labelWidth + 'px'
    },
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm.item.is_required && _vm.item.is_required === 1 ? _c('span', {
    staticClass: "form-red-star"
  }, [_vm._v("*")]) : _vm._e(), _vm._v(" " + _vm._s(_vm.item.name || i18n.tc("383")) + " ")])])], 1) : _vm._e()], 1) : _vm.fieldKey === 14 ? _c('div', [_vm.item.type === 14 ? _c('div', {
    key: _vm.item.id,
    staticClass: "instruction-com font-size-h3-large"
  }, [_vm._v(" " + _vm._s(_vm.item.name) + " ")]) : _vm._e(), _c('div', {
    staticClass: "item-bubble-img instruction-img"
  }, [_c('photo-provider', _vm._l(_vm.item.fieldAttributeList || [], function (image, i) {
    return _c('photo-consumer', {
      key: i,
      attrs: {
        "intro": _vm.$showName(image.value),
        "src": image.value
      }
    }, [_c('img', {
      staticClass: "previewer-demo-img item-bubble-img-i",
      attrs: {
        "src": image.value
      }
    })]);
  }), 1)], 1)]) : _vm.fieldKey === 15 ? _c('div', [_vm.item.type === 15 ? _c('group', {
    key: _vm.item.id
  }, [_c(__unplugin_components_5, {
    attrs: {
      "hidden-border": ""
    },
    on: {
      "on-change": function ($event) {
        _vm.item.tfvvalue = $event.join(',');
      }
    },
    model: {
      value: _vm.item.ovalue,
      callback: function ($$v) {
        _vm.$set(_vm.item, "ovalue", $$v);
      },
      expression: "item.ovalue"
    }
  }, [_c('div', {
    style: {
      position: 'relative',
      width: _vm.labelWidth + 'px'
    },
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm.item.is_required && _vm.item.is_required === 1 ? _c('span', {
    staticClass: "form-red-star"
  }, [_vm._v("*")]) : _vm._e(), _vm._v(" " + _vm._s(_vm.item.name || i18n.tc("384")) + " ")])])], 1) : _vm._e()], 1) : _vm.fieldKey === 16 ? _c('div', [_vm.item.type === 16 ? _c('group', {
    key: _vm.item.id
  }, [_c('Cell', [_c(__unplugin_components_6, {
    attrs: {
      "slot": "title",
      "showTitle": false,
      "value-map": [0, 1]
    },
    slot: "title",
    model: {
      value: _vm.item.ovalue,
      callback: function ($$v) {
        _vm.$set(_vm.item, "ovalue", $$v);
      },
      expression: "item.ovalue"
    }
  }), _c('span', {
    staticClass: "vux-cell-value"
  }, [_vm._v(_vm._s(_vm.item.name))])], 1)], 1) : _vm._e()], 1) : _vm.fieldKey === 17 ? _c('div', [_vm.item.type === 17 ? _c('group', {
    key: _vm.item.id
  }, [_c('a', {
    on: {
      "click": function ($event) {
        _vm.$openLink(_vm.spliteHyperLink(_vm.item.name)[0]);
      }
    }
  }, [_c('Cell', {
    staticClass: "main-color",
    attrs: {
      "title": _vm.spliteHyperLink(_vm.item.name)[1],
      "is-link": ""
    }
  })], 1)]) : _vm._e()], 1) : _vm.fieldKey === 18 ? _c('div', [_vm.item.type === 18 ? _c('group', {
    key: _vm.item.id
  }, [_c('Cell', {
    attrs: {
      "value": _vm.item._name,
      "is-link": ""
    },
    nativeOn: {
      "click": function ($event) {
        _vm.item._isShow = true;
      }
    }
  }, [_c('div', {
    style: {
      position: 'relative',
      width: _vm.labelWidth + 'px'
    },
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm.item.is_required && _vm.item.is_required === 1 ? _c('span', {
    staticClass: "form-red-star"
  }, [_vm._v("*")]) : _vm._e(), _vm._v(" " + _vm._s(_vm.item.name || i18n.tc("528")) + " ")])]), _c(__unplugin_components_7, {
    attrs: {
      "list": _vm.item.dropList,
      "data": _vm.item.arrvalue
    },
    on: {
      "on-change": function (e) {
        return _vm.item.ovalue = e;
      },
      "on-change-name": function ($event) {
        _vm.item._name = $event;
      }
    },
    model: {
      value: _vm.item._isShow,
      callback: function ($$v) {
        _vm.$set(_vm.item, "_isShow", $$v);
      },
      expression: "item._isShow"
    }
  })], 1) : _vm._e()], 1) : _vm.fieldKey === 19 ? _c('div', [_vm.item.type === 19 ? _c('group', {
    key: _vm.item.id
  }, [_c('Cell', {
    attrs: {
      "title": _vm.item.name,
      "value": _vm.calcValue(_vm.item)
    }
  })], 1) : _vm._e()], 1) : _vm.fieldKey === 20 ? _c('div', [_vm.item.type === 20 ? _c('group', {
    key: _vm.item.id
  }, [_c('x-input', {
    attrs: {
      "title": i18n.tc("369"),
      "placeholder": i18n.tc("239"),
      "show-clear": true
    },
    model: {
      value: _vm.item.tfvvalue,
      callback: function ($$v) {
        _vm.$set(_vm.item, "tfvvalue", $$v);
      },
      expression: "item.tfvvalue"
    }
  }, [_c('div', {
    style: {
      position: 'relative',
      width: _vm.labelWidth + 'px'
    },
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm.item.is_required && _vm.item.is_required === 1 ? _c('span', {
    staticClass: "form-red-star"
  }, [_vm._v("*")]) : _vm._e(), _vm._v(" " + _vm._s(_vm.item.name || i18n.tc("167")) + " ")])])], 1) : _vm._e()], 1) : _vm.fieldKey === 21 ? _c('div', [_vm.item.type === 21 ? _c('group', {
    key: _vm.item.id
  }, [_c('Cell', {
    attrs: {
      "title": i18n.tc("370"),
      "link": "",
      "value": _vm.item.tfvvalue ? i18n.tc("322") : i18n.tc("371")
    },
    nativeOn: {
      "click": function ($event) {
        return _vm.handleSign(_vm.item);
      }
    }
  }, [_c('div', {
    style: {
      position: 'relative',
      width: _vm.labelWidth + 'px'
    },
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm.item.is_required && _vm.item.is_required === 1 ? _c('span', {
    staticClass: "form-red-star"
  }, [_vm._v("*")]) : _vm._e(), _vm._v(" " + _vm._s(_vm.item.name || i18n.tc("370")) + " ")])]), _c('div', {
    staticClass: "signature font-size-h3-large",
    on: {
      "click": function ($event) {
        return _vm.handleSign(_vm.item);
      }
    }
  }, [!_vm.item.tfvvalue ? [_vm._v(i18n.tc("323"))] : _c('img', {
    attrs: {
      "src": _vm.item.tfvvalue
    }
  })], 2), _c('div', [_c('WriteExecute', {
    ref: "WriteExecute",
    on: {
      "on-success": _vm.callbackSign
    },
    model: {
      value: _vm.writeShow,
      callback: function ($$v) {
        _vm.writeShow = $$v;
      },
      expression: "writeShow"
    }
  })], 1)], 1) : _vm._e()], 1) : _vm.fieldKey === 22 ? _c('div', [_vm.item.type === 22 ? _c('group', {
    key: _vm.item.id
  }, [_c('Cell', {
    attrs: {
      "title": _vm.item.name
    }
  }, [_c('div', {
    style: {
      position: 'relative',
      width: _vm.labelWidth + 'px'
    },
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm.item.is_required && _vm.item.is_required === 1 ? _c('span', {
    staticClass: "form-red-star"
  }, [_vm._v("*")]) : _vm._e(), _vm._v(" " + _vm._s(_vm.item.name || i18n.tc("20")) + " ")]), _c('Rater', {
    attrs: {
      "value": Number(_vm.item.tfvvalue) || 0,
      "active-color": "#ffb84d",
      "margin": 5,
      "font-size": 20
    },
    on: {
      "input": function ($event) {
        _vm.item.tfvvalue = $event;
      }
    }
  })], 1)], 1) : _vm._e()], 1) : _vm.fieldKey === 23 ? _c('div', [_vm.item.type === 23 ? _c(__unplugin_components_8, {
    key: _vm.item.id,
    attrs: {
      "labelWidth": _vm.labelWidth,
      "format": "YYYY-MM-DD",
      "name": _vm.item.name,
      "required": _vm.item.is_required
    },
    model: {
      value: _vm.item.tfvvalue,
      callback: function ($$v) {
        _vm.$set(_vm.item, "tfvvalue", $$v);
      },
      expression: "item.tfvvalue"
    }
  }) : _vm._e()], 1) : _vm.fieldKey === 24 ? _c('div', [_vm.item.type === 24 ? _c(__unplugin_components_9, {
    key: _vm.item.id,
    attrs: {
      "labelWidth": _vm.labelWidth,
      "format": "HH:mm",
      "name": _vm.item.name,
      "required": _vm.item.is_required
    },
    model: {
      value: _vm.item.tfvvalue,
      callback: function ($$v) {
        _vm.$set(_vm.item, "tfvvalue", $$v);
      },
      expression: "item.tfvvalue"
    }
  }) : _vm._e()], 1) : _vm.fieldKey === 25 ? _c('div', [_vm.item.type === 25 ? _c(__unplugin_components_10, {
    key: _vm.item.id,
    attrs: {
      "labelWidth": _vm.labelWidth,
      "format": "YYYY-MM-DD HH:mm",
      "name": _vm.item.name,
      "required": _vm.item.is_required
    },
    model: {
      value: _vm.item.tfvvalue,
      callback: function ($$v) {
        _vm.$set(_vm.item, "tfvvalue", $$v);
      },
      expression: "item.tfvvalue"
    }
  }) : _vm._e()], 1) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };